/**
 * Unified array formatter with optional styling
 * Formats an array of values into HTML with optional item styling
 * 
 * @param param - The parameter object containing value array or a string
 * @param options - Optional configuration for styling
 * @returns Formatted HTML string
 */
export function formatArray(param: any, options?: { itemStyle?: string; wrapperClass?: string }): string {
  if (!param) {
    return typeof param === 'string' ? param : '';
  }

  if (typeof param === 'string') {
    return param;
  }

  if (!param.value || !Array.isArray(param.value)) {
    return '';
  }

  const wrapperClass = options?.wrapperClass || 'cashsub-table';
  const itemStyle = options?.itemStyle || '';
  
  let html = `<div class="${wrapperClass}">`;
  param.value.forEach((item: any) => {
    html += `<p${itemStyle ? ` style="${itemStyle}"` : ''}>${item}</p>`;
  });
  html += '</div>';
  
  return html;
}

